<!-- Small helper text line below a form field, styled for error or ok status. -->

<script lang="ts" setup>
interface FieldInfoProps {
  type?: 'error' | 'ok';
}

defineProps<FieldInfoProps>();
</script>

<template>
  <p
    :class="[css.info, type && css[type]]"
    :role="type === 'error' ? 'alert' : undefined"
  >
    <slot />
  </p>
</template>

<style lang="scss" module="css">
.info {
  font-size: $font-size-12;
  line-height: 135%;
  margin-top: $spacing-04;
  color: $color-gray-600;
  max-width: 600px;

  &:last-child {
    margin-bottom: $spacing-04;
  }
}

.error {
  color: $color-patient-600;
}

.ok {
  color: $color-green-500;
}
</style>
